import { combineReducers } from 'redux'
import {
  RESET_MEDIA_PLAYER,
  GET_CONTACT_REQUESTED,
  GET_CONTACT_SUCCESS,
  GET_CONTACT_FAILURE,
  REFRESH_CONTACT_REQUESTED,
  REFRESH_CONTACT_SUCCESS,
  REFRESH_CONTACT_FAILURE,
  GET_STORAGEFILE_REQUESTED,
  GET_STORAGEFILE_SUCCESS,
  GET_STORAGEFILE_FAILURE,
  RESTORE_STORAGEFILES_FAILURE,
  GET_ROLE,
  SAVE_ROLE,
  UPDATE_MEDIA_PLAYER_CONTACT_REQUESTED,
  UPDATE_MEDIA_PLAYER_CONTACT_SUCCESS,
  UPDATE_MEDIA_PLAYER_CONTACT_FAILURE,
  UPDATE_REVIEW_GOAL_REQUESTED,
  UPDATE_REVIEW_GOAL_SUCCESS,
  UPDATE_REVIEW_GOAL_FAILURE,
  UPDATE_CONTACT_AFTER_EVALUATION_SAVE,
  UPDATE_CONTACT_AFTER_EVALUATION_RESET,
  GET_TENANT_LICENSED_FEATURES_REQUESTED,
  GET_TENANT_LICENSED_FEATURES_SUCCESS,
  GET_TENANT_LICENSED_FEATURES_FAILURE,
} from './mediaPlayer.constants'
import { createApiReducers, createApiReducerInitialState } from '../../../Helpers/reducer'
import transcriptionReducer from '../Transcription/transcription.reducer'
import textReducer from '../TextPanel/text.reducer'
import chatReducer from '../Chat/chat.reducer'
import desktopReducer from '../DesktopPanel/desktop.reducer'
import speechReducer from '../SpeechPanel/speech.reducer'
import energyReducer from '../AudioPanel/energy.reducer'
import commentsReducer from '../AudioPanel/comments.reducer'
import eventsReducer from '../AudioPanel/events.reducer'
import associatedContactsReducer from '../Explore/AssociatedContacts/associatedContacts.reducer'
import surveyReducer from '../Explore/PostCallSurvey/surveyResults.reducer'
import metadataReducer from '../Explore/MetadataEditor/metadata.reducer'
import findSimilarReducer from '../Explore/FindSimilar/findSimilar.reducer'

const initialState = {
  contact: {
    error: false,
    loading: true,
    data: {},
    updating: false,
  },
  storageFile: {
    error: false,
    loading: true,
    data: {},
  },
  licensedFeatures: {
    error: false,
    loading: true,
    data: [],
  },
  ...createApiReducerInitialState('role', null),
}

const mainReducer = (state = initialState, action) => {
  const reducers = {
    ...createApiReducers(GET_ROLE, 'role', null),
    ...createApiReducers(SAVE_ROLE, 'role', null),
  }

  state = reducers[action.type] ? reducers[action.type](state, action) : state

  switch (action.type) {
    case RESET_MEDIA_PLAYER:
      return {
        ...initialState,
      }

    case GET_CONTACT_REQUESTED:
      return {
        ...state,
        contact: {
          updating: state.contact.updating,
          error: false,
          loading: true,
          data: {},
        },
      }

    case GET_CONTACT_SUCCESS:
      return {
        ...state,
        contact: {
          updating: state.contact.updating,
          error: false,
          loading: false,
          data: action.contact,
        },
      }

    case GET_CONTACT_FAILURE:
      return {
        ...state,
        contact: {
          updating: state.contact.updating,
          error: action.error.message,
          loading: false,
          data: {},
        },
      }
    case UPDATE_MEDIA_PLAYER_CONTACT_REQUESTED:
      // if this ever fires while its already updating, gonna have to figure out how to handle con
      return {
        ...state,
        contact: {
          ...state.contact,
          updating: { ...action.contact },
        },
      }

    case UPDATE_MEDIA_PLAYER_CONTACT_SUCCESS:
      return {
        ...state,
        contact: {
          ...state.contact,
          updating: false,
          data: { ...state.contact.updating },
        },
      }

    case UPDATE_MEDIA_PLAYER_CONTACT_FAILURE:
      // TODO: how should this be handled?
      return {
        ...state,
        contact: {
          ...state.contact,
          updating: false,
        },
      }

    case UPDATE_REVIEW_GOAL_REQUESTED:
      return {
        ...state,
        contact: {
          ...state.contact,
          updating: { ...action.goalUpdate },
        },
      }

    case UPDATE_REVIEW_GOAL_SUCCESS:
      return {
        ...state,
        contact: {
          ...state.contact,
          updating: false,
        },
      }

    case UPDATE_REVIEW_GOAL_FAILURE:
      return {
        ...state,
        contact: {
          ...state.contact,
          updating: false,
        },
      }

    case REFRESH_CONTACT_REQUESTED:
      return {
        ...state,
      }

    case REFRESH_CONTACT_SUCCESS:
      return {
        ...state,
        contact: {
          updating: state.contact.updating,
          error: false,
          data: action.contact,
          loading: false,
        },
      }

    case REFRESH_CONTACT_FAILURE:
      return {
        ...state,
        contact: {
          error: action.error.message,
          updating: state.contact.updating,
          data: {},
          loading: false,
        },
      }

    case GET_STORAGEFILE_REQUESTED:
      return {
        ...state,
        storageFile: {
          loading: true,
          error: false,
          data: {},
        },
      }

    case GET_STORAGEFILE_SUCCESS:
      return {
        ...state,
        storageFile: {
          error: false,
          loading: false,
          data: action.data,
        },
      }

    case GET_STORAGEFILE_FAILURE:
      return {
        ...state,
        storageFile: {
          loading: false,
          error: action.error.message,
          data: {},
        },
      }

    case RESTORE_STORAGEFILES_FAILURE:
      return {
        ...state,
        storageFile: {
          loading: false,
          error: action.error.message,
          data: { ...state.storageFile.data },
        },
      }

    case UPDATE_CONTACT_AFTER_EVALUATION_SAVE:
      return {
        ...state,
        contact: {
          ...state.contact,
          data: {
            ...state.contact.data,
            evalStateId: action.payload.state.stateId,
            evalForm: {
              ...state.contact.data.evalForm,
              ...action.payload.evalForm,
            },
            evaluator: {
              ...state.contact.data.evaluator,
              ...action.payload.evaluator,
            },
            approver:
              action.payload.approver === null
                ? {
                  $ref: '/api/rest/recording/person/0',
                  firstName: null,
                  lastName: null,
                  displayId: '0',
                  username: null,
                }
                : action.payload.approver,
            evaluation: {
              ...state.contact.data.evaluation,
              $ref: `/api/rest/recording/contact/${action.contactId}/eval/${action.payload.id}`,
              id: action.payload.id,
              stateId: action.payload.state.stateId,
              totalScore: action.payload.totalScore,
              evaluated: action.payload.evaluated,
              evaluatedTz: action.payload.evaluatedTz,
              responseDate: action.payload.responseDate,
              responseState: action.payload.responseState === null ? null : action.payload.responseState.stateId,
            },
          },
        },
      }

    case UPDATE_CONTACT_AFTER_EVALUATION_RESET:
      return {
        ...state,
        contact: {
          ...state.contact,
          data: {
            ...state.contact.data,
            evalStateId: 0,
            evaluator: {
              $ref: '/api/rest/recording/person/0',
              firstName: null,
              lastName: null,
              displayId: '0',
              username: null,
            },
            approver: {
              $ref: '/api/rest/recording/person/0',
              firstName: null,
              lastName: null,
              displayId: '0',
              username: null,
            },
            evaluation: null,
          },
        },
      }

    case GET_TENANT_LICENSED_FEATURES_REQUESTED:
      return {
        ...state,
        licensedFeatures: {
          loading: true,
          error: false,
          data: [],
        },
      }

    case GET_TENANT_LICENSED_FEATURES_SUCCESS:
      return {
        ...state,
        licensedFeatures: {
          error: false,
          loading: false,
          data: action.data,
        },
      }

    case GET_TENANT_LICENSED_FEATURES_FAILURE:
      return {
        ...state,
        licensedFeatures: {
          loading: false,
          error: action.error.message,
          data: [],
        },
      }

    default:
      return state
  }
}

export default combineReducers({
  main: mainReducer,
  transcription: transcriptionReducer,
  text: textReducer,                // legacy text data in the store
  chat: chatReducer,                // omnichannel data in the store
  desktop: desktopReducer,
  speech: speechReducer,
  energy: energyReducer,
  comments: commentsReducer,
  events: eventsReducer,
  associatedContacts: associatedContactsReducer,
  survey: surveyReducer,
  metadata: metadataReducer,
  similarContacts: findSimilarReducer,
})
